
import {Fetch} from "../../utils/storage"
import   {Api} from "../../utils/api"
import {ParseTime} from "../../utils/time"
import NotFound from '../../components/NotFound'
import Pay from "../../utils/pay"
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'



export default {
name: 'blank',
components: {
NotFound,
Group,
Cell
},
filters: {
},
data () {
return {
OrderList:[],
UserID:0,
Limit:999,
Page:1,
}
},
created () {
this.UserID = Fetch("ID")
this.fetchOrderList()
},
methods : {
ParseTime,
handleReceiptEdit(mr) {
let id = mr.ID
this.$router.push(`/order/order-meeting-receipt/detail/${id}`)
},
async fetchOrderList() {
let res = await Api('GetOrderList',{
Data:{
UserID:this.UserID,
MeetingType: "training"
},
Limit:this.Limit,
Offset: (this.Page-1) * this.Limit,
Order:'updated_at desc',
Preloads:[
{Column:'OrderMeetingReceipts'},
{Column:'OrderInfo'}
]
})
this.OrderList = res.data.List || []
},
handleOrderDelete(id) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认删除该订单？删除后不可恢复！</span>',
async onConfirm() {
try {
await Api('DeleteOrder', {}, {}, [{Name: 'ID', Value: id}])
_this.$vux.toast.show({
text: '订单已删除！',
type: 'text',
width: '3rem'
})
_this.Page = 1
_this.fetchOrderList()
} catch (err) {
_this.$vux.toast.show({
text: '订单删除错误:' + err.message,
type: 'text',
width: '3rem'
})

}
}
})
},
parseMeetingTime(str) {
let timeArr = str.split('----')
if (timeArr.length !== 2) {
return ''
}
let start = ParseTime(timeArr[0],'{y}-{m}-{d}')
let end = ParseTime(timeArr[1],'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
async handleWechatPay(OrderID) {
try{
let _this = this
let res = await Api('GetMeetingPreOrder', {
OrderID: OrderID
})

Pay.invoke(res.data,function (){
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">会议已报名并支付成功</p>
<span style="font-size:20px">您可打开"个人中心"，在"已支付会议"中查看报名信息，点击下方确认按钮返回"会议广场"</span>
`,
confirmText:"返回首页",
cancelText:"留在此页",
onConfirm(){
_this.$router.push({
path: '/'
})
},
onCancel() {
_this.fetchOrderDetail()
}
})
})
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
},
}
}
